import { Button } from "@legal-500/legal500-design-system";
import type { ParsedTestimonialStatusCsv } from "./parseTestimonialStatusCsv.js";
import { DUPLICATE_REASON, downloadInvalidRowsCsv } from "./testimonialStatusCsv.js";
import styles from "../PipelineBrowser.module.css";

const DISPLAY_CAP = 50;

type ParsedCsvSummaryProps = {
  parsed: ParsedTestimonialStatusCsv;
  fileName: string;
};

export function ParsedCsvSummary({ parsed, fileName }: ParsedCsvSummaryProps) {
  const problems = [
    ...parsed.invalid.map(row => ({
      key: `line-${row.line}`,
      label: `Line ${row.line}: ${row.testimonialId || "(empty)"} / ${row.status || "(empty)"} — ${row.reason}`,
    })),
    ...parsed.duplicates.map(id => ({ key: `dup-${id}`, label: `${id} — ${DUPLICATE_REASON}` })),
  ];
  const shown = problems.slice(0, DISPLAY_CAP);
  const hidden = problems.length - shown.length;

  return (
    <>
      <div className={styles.syncStateMessage}>
        {fileName}: <strong>{parsed.rows.length}</strong> valid rows,{" "}
        <strong>{parsed.invalid.length}</strong> invalid,{" "}
        <strong>{parsed.duplicates.length}</strong> duplicates
      </div>
      {parsed.duplicates.length > 0 && (
        <div className={styles.mappingError}>
          Duplicate testimonial_id values must be removed before this file can be run.
        </div>
      )}
      {problems.length > 0 && (
        <>
          <ul className={styles.problemList}>
            {shown.map(problem => (
              <li key={problem.key}>{problem.label}</li>
            ))}
          </ul>
          <div className={styles.syncStateRow}>
            {hidden > 0 && <span>…and {hidden} more.</span>}
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              onClick={() => downloadInvalidRowsCsv(parsed.invalid, parsed.duplicates, new Date())}
            >
              Download invalid rows CSV
            </Button>
          </div>
        </>
      )}
    </>
  );
}
